.vf-ledger-scope {
  --vf-page: var(--color-bg-page);
  --vf-surface: var(--color-bg-card);
  --vf-sunken: var(--color-bg-input);
  --vf-ink-1: var(--color-text-1);
  --vf-ink-2: var(--color-text-2);
  --vf-ink-3: var(--color-text-3);
  --vf-ink-4: var(--color-text-4);
  --vf-line-1: var(--color-divider);
  --vf-line-2: var(--color-line-2);
  --vf-border: var(--color-border);
  --vf-accent: var(--color-primary-500);
  --vf-accent-ink: var(--color-primary-700);
  --vf-accent-soft: var(--color-primary-50);
  --vf-success: var(--color-success-600);
  --vf-success-soft: var(--color-success-50);
  --vf-warning: var(--color-warning-600);
  --vf-warning-soft: var(--color-warning-50);
  --vf-danger: var(--color-danger-600);
  --vf-danger-soft: var(--color-danger-50);
  --vf-info: var(--color-primary-700);
  --vf-info-soft: var(--color-primary-50);
  --vf-muted: var(--color-neutral-500);
  --vf-radius-panel: var(--radius-xs);
  --vf-radius-chip: 4px;
  color: var(--vf-ink-1);
  font-variant-numeric: tabular-nums;
}

.vf-ledger-page-header {
  display: flex;
  min-width: 0;
  align-items: flex-end;
  justify-content: space-between;
  gap: 20px;
  padding: 12px 0 14px;
  border-bottom: 3px solid var(--vf-ink-1);
  background: transparent;
}

.vf-ledger-page-header__copy {
  min-width: 0;
}

.vf-ledger-page-header__title {
  margin: 0;
  color: var(--vf-ink-1);
  font-size: 20px;
  font-weight: 700;
  line-height: 1.3;
}

.vf-ledger-page-header__subtitle {
  margin: 4px 0 0;
  color: var(--vf-ink-3);
  font-size: 13px;
  line-height: 1.45;
}

.vf-ledger-page-header__actions {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.vf-ledger-panel.ant-card {
  height: 100%;
  overflow: hidden;
  border: 1px solid var(--vf-border);
  border-radius: var(--vf-radius-panel);
  background: var(--vf-surface);
  box-shadow: none;
}

.vf-ledger-panel .ant-card-head {
  min-height: 46px;
  padding: 0 14px;
  border-bottom: 0;
}

.vf-ledger-panel .ant-card-head-title,
.vf-ledger-panel .ant-card-extra {
  padding: 12px 0 6px;
}

.vf-ledger-panel .ant-card-body {
  padding: 10px 14px 14px;
}

.vf-ledger-panel__heading {
  display: flex;
  min-width: 0;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
}

.vf-ledger-panel__title {
  color: var(--vf-ink-1);
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
}

.vf-ledger-panel__subtitle {
  min-width: 0;
  overflow: hidden;
  color: var(--vf-ink-3);
  font-size: 12px;
  font-weight: 400;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vf-ledger-kpis {
  display: grid;
  overflow: hidden;
  border: 1px solid var(--vf-border);
  border-radius: var(--vf-radius-panel);
  background: var(--vf-surface);
}

.vf-ledger-kpis--columns-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.vf-ledger-kpis--columns-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.vf-ledger-kpis--columns-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.vf-ledger-kpis--columns-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.vf-ledger-kpis--columns-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

.vf-ledger-kpi {
  appearance: none;
  min-width: 0;
  padding: 12px 14px;
  text-align: left;
  background: var(--vf-surface);
  border: 0;
  border-left: 1px solid var(--vf-line-1);
  border-radius: 0;
  font: inherit;
}

.vf-ledger-kpi:first-child {
  border-left: 0;
}

.vf-ledger-kpis--columns-2 .vf-ledger-kpi:nth-child(2n + 1),
.vf-ledger-kpis--columns-3 .vf-ledger-kpi:nth-child(3n + 1),
.vf-ledger-kpis--columns-4 .vf-ledger-kpi:nth-child(4n + 1),
.vf-ledger-kpis--columns-5 .vf-ledger-kpi:nth-child(5n + 1) {
  border-left: 0;
}

.vf-ledger-kpis--columns-6 .vf-ledger-kpi:nth-child(6n + 1) {
  border-left: 0;
}

.vf-ledger-kpis--columns-2 .vf-ledger-kpi:nth-child(n + 3),
.vf-ledger-kpis--columns-3 .vf-ledger-kpi:nth-child(n + 4),
.vf-ledger-kpis--columns-4 .vf-ledger-kpi:nth-child(n + 5),
.vf-ledger-kpis--columns-5 .vf-ledger-kpi:nth-child(n + 6) {
  border-top: 1px solid var(--vf-line-1);
}

.vf-ledger-kpis--columns-6 .vf-ledger-kpi:nth-child(n + 7) {
  border-top: 1px solid var(--vf-line-1);
}

.vf-ledger-kpi__label {
  display: block;
  color: var(--vf-ink-3);
  font-size: 12px;
  line-height: 1.35;
}

.vf-ledger-kpi__main {
  display: flex;
  min-height: 32px;
  align-items: center;
  gap: 8px;
  margin-top: 3px;
}

.vf-ledger-kpi__value {
  min-width: 0;
  color: var(--vf-ink-1);
  font-size: 24px;
  font-weight: 700;
  line-height: 1.15;
  white-space: nowrap;
}

.vf-ledger-kpi__visual {
  width: 54px;
  min-width: 42px;
  height: 24px;
  margin-left: auto;
}

.vf-ledger-kpi__hint {
  display: block;
  min-width: 0;
  margin-top: 3px;
  overflow: hidden;
  color: var(--vf-ink-3);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vf-ledger-kpis--compact .vf-ledger-kpi {
  padding: 9px 12px;
}

.vf-ledger-kpis--compact .vf-ledger-kpi__main {
  min-height: 28px;
}

.vf-ledger-kpis--compact .vf-ledger-kpi__value {
  font-size: 20px;
}

.vf-ledger-kpi--interactive:not(:disabled) {
  cursor: pointer;
}

.vf-ledger-kpi--interactive:not(:disabled):hover {
  background: var(--vf-accent-soft);
}

.vf-ledger-kpi--interactive:focus-visible {
  position: relative;
  z-index: 1;
  outline: 2px solid var(--vf-accent);
  outline-offset: -2px;
}

.vf-ledger-kpi--interactive:disabled {
  cursor: default;
}

.vf-ledger-kpi--success .vf-ledger-kpi__hint {
  color: var(--vf-success);
}

.vf-ledger-kpi--warning .vf-ledger-kpi__hint {
  color: var(--vf-warning);
}

.vf-ledger-kpi--danger .vf-ledger-kpi__hint {
  color: var(--vf-danger);
}

.vf-ledger-kpi--info .vf-ledger-kpi__hint {
  color: var(--vf-info);
}

.vf-ledger-pacing {
  position: relative;
  display: block;
  width: 100%;
  height: 8px;
  overflow: visible;
  border-radius: 2px;
  background: var(--vf-sunken);
}

.vf-ledger-pacing__fill {
  position: absolute;
  inset: 0 auto 0 0;
  border-radius: 2px;
  background: var(--vf-accent);
}

.vf-ledger-pacing__fill--success {
  background: var(--vf-success);
}

.vf-ledger-pacing__fill--warning {
  background: var(--vf-warning);
}

.vf-ledger-pacing__fill--danger {
  background: var(--vf-danger);
}

.vf-ledger-pacing__fill--info {
  background: var(--vf-info);
}

.vf-ledger-pacing__marker {
  position: absolute;
  top: -3px;
  bottom: -3px;
  width: 2px;
  background: var(--vf-ink-1);
  transform: translateX(-1px);
}

.vf-ledger-entity-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  flex: none;
  border-radius: 2px;
}

.vf-ledger-status {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border-radius: var(--vf-radius-chip);
  background: var(--vf-sunken);
  color: var(--vf-ink-2);
  font-size: 11px;
  font-weight: 600;
  line-height: 1.35;
  white-space: nowrap;
}

.vf-ledger-status::before {
  width: 5px;
  height: 5px;
  border-radius: 1px;
  background: currentColor;
  content: "";
}

.vf-ledger-status--success {
  background: var(--vf-success-soft);
  color: var(--vf-success);
}

.vf-ledger-status--warning {
  background: var(--vf-warning-soft);
  color: var(--vf-warning);
}

.vf-ledger-status--danger {
  background: var(--vf-danger-soft);
  color: var(--vf-danger);
}

.vf-ledger-status--info {
  background: var(--vf-info-soft);
  color: var(--vf-info);
}

.vf-ledger-status--muted {
  background: var(--vf-sunken);
  color: var(--vf-muted);
}

.vf-ledger-def-list {
  display: flex;
  flex-direction: column;
  margin: 0;
  --vf-ledger-def-label-width: 104px;
}

.vf-ledger-def-list__row {
  display: flex;
  align-items: center;
  gap: 16px;
  min-width: 0;
  padding: 7px 0;
  border-bottom: 1px solid var(--vf-line-1);
}

.vf-ledger-def-list__row:first-child {
  padding-top: 2px;
}

.vf-ledger-def-list__row:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}

.vf-ledger-def-list__label {
  width: var(--vf-ledger-def-label-width);
  flex: none;
  margin: 0;
  color: var(--vf-ink-3);
  font-size: 12px;
  line-height: 1.45;
}

.vf-ledger-def-list__value {
  display: flex;
  min-width: 0;
  flex: 1;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin: 0;
  color: var(--vf-ink-1);
  font-size: 14px;
  line-height: 1.45;
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.vf-ledger-def-list__content {
  min-width: 0;
  overflow-wrap: anywhere;
}

.vf-ledger-def-list__value--minor {
  color: var(--vf-ink-3);
  font-size: 12px;
}

.vf-ledger-def-list__control {
  display: inline-flex;
  flex: none;
  align-items: center;
}

@media (max-width: 520px) {
  .vf-ledger-def-list__row {
    align-items: flex-start;
  }

  .vf-ledger-def-list__label {
    width: min(36%, var(--vf-ledger-def-label-width));
  }
}

@media (max-width: 1280px) {
  .vf-ledger-kpis--columns-4,
  .vf-ledger-kpis--columns-5,
  .vf-ledger-kpis--columns-6 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .vf-ledger-kpis--columns-4 .vf-ledger-kpi:nth-child(4),
  .vf-ledger-kpis--columns-5 .vf-ledger-kpi:nth-child(4),
  .vf-ledger-kpis--columns-6 .vf-ledger-kpi:nth-child(4) {
    border-left: 0;
  }

  .vf-ledger-kpis--columns-4 .vf-ledger-kpi:nth-child(n + 4),
  .vf-ledger-kpis--columns-5 .vf-ledger-kpi:nth-child(n + 4),
  .vf-ledger-kpis--columns-6 .vf-ledger-kpi:nth-child(n + 4) {
    border-top: 1px solid var(--vf-line-1);
  }
}

@media (max-width: 1024px) {
  .vf-ledger-page-header {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
  }

  .vf-ledger-page-header__actions {
    width: 100%;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .vf-ledger-kpis--columns-3,
  .vf-ledger-kpis--columns-4,
  .vf-ledger-kpis--columns-5,
  .vf-ledger-kpis--columns-6 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .vf-ledger-kpis--columns-3 .vf-ledger-kpi:nth-child(odd),
  .vf-ledger-kpis--columns-4 .vf-ledger-kpi:nth-child(odd),
  .vf-ledger-kpis--columns-5 .vf-ledger-kpi:nth-child(odd),
  .vf-ledger-kpis--columns-6 .vf-ledger-kpi:nth-child(odd) {
    border-left: 0;
  }

  .vf-ledger-kpis--columns-3 .vf-ledger-kpi:nth-child(even),
  .vf-ledger-kpis--columns-4 .vf-ledger-kpi:nth-child(even),
  .vf-ledger-kpis--columns-5 .vf-ledger-kpi:nth-child(even),
  .vf-ledger-kpis--columns-6 .vf-ledger-kpi:nth-child(even) {
    border-left: 1px solid var(--vf-line-1);
  }

  .vf-ledger-kpis--columns-3 .vf-ledger-kpi:nth-child(n + 3),
  .vf-ledger-kpis--columns-4 .vf-ledger-kpi:nth-child(n + 3),
  .vf-ledger-kpis--columns-5 .vf-ledger-kpi:nth-child(n + 3),
  .vf-ledger-kpis--columns-6 .vf-ledger-kpi:nth-child(n + 3) {
    border-top: 1px solid var(--vf-line-1);
  }

  .vf-ledger-panel__heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 2px;
  }
}

@media (min-width: 1024px) {
  .vf-ledger-kpis--columns-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .vf-ledger-kpis--columns-3 .vf-ledger-kpi:nth-child(n) {
    border-top: 0;
    border-left: 1px solid var(--vf-line-1);
  }

  .vf-ledger-kpis--columns-3 .vf-ledger-kpi:nth-child(3n + 1) {
    border-left: 0;
  }

  .vf-ledger-kpis--columns-3 .vf-ledger-kpi:nth-child(n + 4) {
    border-top: 1px solid var(--vf-line-1);
  }
}

.vf-ledger-table .ant-table-thead > tr > th {
  background: transparent;
  border-bottom: 3px solid var(--vf-ink-1);
}

@media (max-width: 520px) {
  .vf-ledger-kpis {
    grid-template-columns: minmax(0, 1fr);
  }

  .vf-ledger-kpi,
  .vf-ledger-kpi:nth-child(n) {
    border-top: 1px solid var(--vf-line-1);
    border-left: 0;
  }

  .vf-ledger-kpi:first-child {
    border-top: 0;
  }
}
